module.exports = __webpack_public_path__ + "static/persona1-thumb-956a91627af6d8feef66ceda72d28d86.png";